"use strict";

angular.module("exploitation")

	.controller("JobsCtrlParent", ["$scope", "OpenImportsService", "AdminClientsService", "Utils", "$uibModal", "toastr", "$location", "ENV", function ($scope, OpenImportsService, AdminClientsService, Utils, $uibModal, toastr) {

		// STATE CONSTANTS
		const OK = "OK";
		const FAILED = "FAILED";
		const CANCELLED = "CANCELLED";
		const STARTED = "STARTED";
		const PENDING = "PENDING";
		const TIMEOUT = "TIMEOUT";
		const DUPLICATE = "DUPLICATE";

		// ACTION CONSTANTS
		const FILE_TRANSFER = "FILE_TRANSFER";
		const FILE_CLASSIFICATION = "FILE_CLASSIFICATION";
		const IMPORT = "IMPORT";
		const IMPORT_UTTU = "IMPORT_UTTU";
		const IMPORT_GTFS = "IMPORT_GTFS";
		const IMPORT_GTFS_FLEX = "IMPORT_GTFS_FLEX";
		const IMPORT_GTFS_FULL_FLEX = "IMPORT_GTFS_FULL_FLEX";
		const VALIDATION_LEVEL_1 = "VALIDATION_LEVEL_1";
		const DATASPACE_TRANSFER = "DATASPACE_TRANSFER";
		const VALIDATION_LEVEL_2 = "VALIDATION_LEVEL_2";
		const EXPORT_NETEX = "EXPORT_NETEX";
		const EXPORT = "EXPORT";
		const EXPORT_CONCERTO = "EXPORT_CONCERTO";
		const FILE_ANALYZE = "FILE_ANALYZE";

		$scope.data = {};

		$scope.getStatusClass = function (status) {
			switch (status) {
				case OK:
					return "success";
				case FAILED:
				case TIMEOUT:
					return "danger";
				case CANCELLED:
				case DUPLICATE:
					return "warning";
				case STARTED:
				case PENDING:
					return "info";
				default:
					return "default";
			}
		};

		$scope.hasGtfsFlexEvent = function (job) {
			if (job == null || job == undefined) {
				return false;
			}
			return job.flexible;
		};

		/*
		 * Détermine l'état de l'étape d'un job (En cours, en attente, terminé...)
		 */
		$scope.checkEvent = function (job, event) {

			if (job==null || job ==undefined){
				return;
			}

			switch (event) {
				case FILE_TRANSFER:
					if (job.events.find(event => event.action === FILE_TRANSFER && event.state === FAILED) ||
						job.events.find(event => event.action === FILE_CLASSIFICATION && event.state === FAILED)) {
						return "fa fa-exclamation-triangle error";
					} else if (job.events.find(event => event.action === FILE_TRANSFER && event.state === OK) &&
						job.events.find(event => event.action === FILE_CLASSIFICATION && event.state === OK)) {
						return "fa fa-check success";
					} else if (job.events.find(event => event.action === FILE_TRANSFER && event.state === CANCELLED) ||
						job.events.find(event => event.action === FILE_CLASSIFICATION && event.state === CANCELLED)) {
						return "fa fa-exclamation-triangle warning";
					} else if (job.events.find(event => event.action === FILE_TRANSFER && event.state === STARTED) ||
						job.events.find(event => event.action === FILE_CLASSIFICATION && event.state === STARTED)) {
						return "fa fa-cog info";
					} else if (job.events.find(event => event.action === FILE_TRANSFER && event.state === PENDING) ||
						job.events.find(event => event.action === FILE_CLASSIFICATION && event.state === PENDING)) {
						return "fa fa-hourglass warning";
					}
					return "fa fa-clock";

				case IMPORT_GTFS:
					return checkEventHelperByType(job, IMPORT, 'GTFS_FLEX', false);

				case IMPORT_GTFS_FLEX:
					return checkEventHelperByType(job, IMPORT_UTTU, 'GTFS_FLEX', true);

				case IMPORT_GTFS_FULL_FLEX:
					return checkEventHelperByType(job, IMPORT_UTTU, 'GTFS_FULL_FLEX', true);

				case IMPORT:
					return checkEventHelper(job, IMPORT);

				case VALIDATION_LEVEL_1:
					return checkEventHelper(job, VALIDATION_LEVEL_1);

				case DATASPACE_TRANSFER:
					return checkEventHelper(job, DATASPACE_TRANSFER);

				case VALIDATION_LEVEL_2:
					return checkEventHelper(job, VALIDATION_LEVEL_2);

				case EXPORT_NETEX:
					return checkEventHelper(job, EXPORT_NETEX);

				case EXPORT:
					return checkEventHelper(job, EXPORT);

				case EXPORT_CONCERTO:
					return checkEventHelper(job, EXPORT_CONCERTO);

				case FILE_ANALYZE:
					return checkEventHelper(job, FILE_ANALYZE);
			}
		};

		/*
 * Helper filtré par type d'event.
 * Si matchType=true, on ne regarde que les events dont type === targetType
 * Si matchType=false, on ne regarde que les events dont type !== targetType
 */
		function checkEventHelperByType(job, action, targetType, matchType) {
			if (job == null || job == undefined) {
				return;
			}

			var filteredEvents = job.events.filter(function (e) {
				if (matchType) {
					return e.action === action && e.type === targetType;
				} else {
					return e.action === action && e.type !== targetType;
				}
			});

			if (filteredEvents.find(e => e.state === FAILED)) {
				return "fa fa-exclamation-triangle error";
			} else if (filteredEvents.find(e => e.state === OK)) {
				return "fa fa-check success";
			} else if (filteredEvents.find(e => e.state === CANCELLED)) {
				return "fa fa-exclamation-triangle warning";
			} else if (filteredEvents.find(e => e.state === STARTED)) {
				return "fa fa-cog info";
			} else if (filteredEvents.find(e => e.state === PENDING)) {
				return "fa fa-hourglass warning";
			}
			return "fa fa-clock";
		}

		function checkEventHelper(job, action) {
			if (job==null || job ==undefined){
				return;
			}
			if (job.events.find(event => event.action === action && event.state === FAILED)) {
				return "fa fa-exclamation-triangle error";
			} else if (job.events.find(event => event.action === action && event.state === OK)) {
				return "fa fa-check success";
			} else if (job.events.find(event => event.action === action && event.state === CANCELLED)) {
				return "fa fa-exclamation-triangle warning";
			} else if (job.events.find(event => event.action === action && event.state === STARTED)) {
				return "fa fa-cog info";
			} else if (job.events.find(event => event.action === action && event.state === PENDING)) {
				return "fa fa-hourglass warning";
			}
			return "fa fa-clock";
		}

		/*
		 * Calcule l'état réel du job en tenant compte des 2 imports si flexible
		 */
		$scope.getEffectiveEndState = function (job) {
			if (!job.flexible) {
				return job.endState;
			}

			// Récupérer le dernier state de chaque import par type
			var gtfsEvents = job.events.filter(function (e) {
				return e.action === IMPORT && e.type !== 'GTFS_FLEX';
			});
			var flexEvents = job.events.filter(function (e) {
				return e.action === IMPORT && e.type === 'GTFS_FLEX';
			});

			var gtfsState = gtfsEvents.length > 0 ? gtfsEvents[gtfsEvents.length - 1].state : null;
			var flexState = flexEvents.length > 0 ? flexEvents[flexEvents.length - 1].state : null;

			// Si l'un des deux est FAILED ou TIMEOUT -> FAILED
			if (gtfsState === FAILED || flexState === FAILED ||
				gtfsState === 'TIMEOUT' || flexState === 'TIMEOUT') {
				return 'FAILED';
			}
			// Si l'un des deux est CANCELLED -> CANCELLED
			if (gtfsState === 'CANCELLED' || flexState === 'CANCELLED') {
				return 'CANCELLED';
			}
			// Les deux doivent être OK pour que le job soit OK
			if (gtfsState === OK && flexState === OK) {
				// Vérifier aussi la validation si elle existe
				return job.endState;
			}
			// Sinon, au moins un est encore en cours
			if (gtfsState === STARTED || flexState === STARTED) {
				return 'STARTED';
			}
			if (gtfsState === PENDING || flexState === PENDING) {
				return 'PENDING';
			}

			return job.endState;
		};


		/*
 		* Récupère le titre selon s'il s'agit d'un import ou d'une validation
 		*/
		$scope.getTitle = function (job) {
			if (job.events.find(event => event.action === FILE_TRANSFER) ||
				job.events.find(event => event.action === FILE_CLASSIFICATION) ||
				job.events.find(event => event.action === IMPORT)) {
				return "IMPORT";
			} else if (
				(
					!job.events.find(event => event.action === FILE_TRANSFER) &&
					!job.events.find(event => event.action === FILE_CLASSIFICATION) &&
					!job.events.find(event => event.action === IMPORT) &&
					!job.events.find(event => event.action === VALIDATION_LEVEL_1) &&
					!job.events.find(event => event.action === DATASPACE_TRANSFER) &&
					!job.events.find(event => event.action === VALIDATION_LEVEL_2)
				) &&
				job.events.find(event => event.action === EXPORT_NETEX) ||
				job.events.find(event => event.action === EXPORT) ||
				job.events.find(event => event.action === EXPORT_CONCERTO)) {
				return "EXPORT";
			}
			return "VALIDATION";
		};

		/*
 		* Récupère la date formatée d'un job
 		*/
		$scope.getDate = function (job) {
			if (job == null || job == undefined){
				return ;
			}
			const date = new Date(job.firstEvent);
			return date.toLocaleString("fr-FR");
		};

		$scope.downloadDataFile = function (job) {
			if (job.fileName !== undefined) {
				AdminClientsService.getReferentialId().then((refId) => {
						// Téléchargement en appelant Marduk
						OpenImportsService.getMobiitiImportDataFile(refId, job.fileName)
							.then((response) => {
								const data = response.data;
								let blob = new Blob([data], {type: "octet/stream"});
								let a = document.createElement("a");
								a.href = (window.URL || window.webkitURL).createObjectURL(blob);
								a.target = "_blank";
								a.download = job.fileName;
								document.body.appendChild(a);
								a.click();
							})
							// Si introuvable avec Marduk, on essaye avec Okina/Chouette
							.catch(() => {
								const event = job.events.find(event => event.action === "IMPORT" && event.chouetteJobId);
								if (event) {
									OpenImportsService.getImport(event.referential, event.chouetteJobId)
										.then((response) =>{
											$scope.downloadDataFile(response.data);
										})
								}
							});
					}
				);
			} else {
				toastr.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement");
			}
		};

	}]);